import { Component } from '@angular/core';

import { navItems } from './_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {

  public allNavItems = navItems;
  public navItems: any[] = [];

  private readonly currentUser = JSON.parse(localStorage.getItem('current_user') || "");
  private userRoles: any[] = this.currentUser ? this.currentUser.roles : [];


  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor() {
    if (this.userRoles && !(this.userRoles.includes('ADMIN') || this.userRoles.includes('ROLE_ADMIN'))) {

      const excludeArray = ['Admin Panel', 'Categories', 'Departments', 'Employer', 'Nationality', 'Injury', 'Service', 'Area', 'User', 'Program', 'Items'];
      const filteredArray = this.allNavItems.filter(obj => !excludeArray.includes(obj.name ? obj.name : ""));
      this.navItems = filteredArray;

    } else {
      this.navItems = this.allNavItems;
    }
  }
}
